import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

let initPromise: Promise<void> | null = null;

/** Ensures MSAL is initialized and any redirect response is handled (single-flight). */
export function ensureMsalInitialized(): Promise<void> {
  if (!initPromise) {
    initPromise = msalInstance
      .initialize()
      .then(() => msalInstance.handleRedirectPromise())
      .then(() => undefined)
      .catch((error) => {
        initPromise = null;
        throw error;
      });
  }
  return initPromise;
}
